<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app >
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;">订单列表</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <v-container>
<!--
          <v-card style="margin-bottom:0.7rem;">
            <v-row style="text-align:center;">
              <v-col>
                <div style="font-size:0.9rem;color:#409EFF">待处理</div>
                <div style="font-size:1.3rem;">{{statData.b0}}</div>
              </v-col>
               <v-col>
                <div style="font-size:0.9rem;color:#FF9900">处理中</div>
                <div style="font-size:1.3rem;">{{statData.b2}}</div>
              </v-col>
              <v-col>
                <div style="font-size:0.9rem;color:#67C23A">已完成</div>
                <div style="font-size:1.3rem;">{{statData.b4}}</div>
              </v-col>
            </v-row>
          </v-card> -->

          <div style="margin-bottom:0.7rem;text-align:right;font-size:0.9rem;color:#9E9E9E;">
              <span style="margin-right:0.6rem;">筛选:</span>
              <i class="fa fa-filter" style="margin-right:0.2rem;" aria-hidden="true"></i>
              <select v-model="listFilter.biz_sid" @change="changeBidSid">
                <option :value="item.primitive" v-for="(item,index) in stepList" :key="index">{{item.label}}</option>
              </select>
              <i class="fa fa-angle-down" aria-hidden="true" style="font-size:1.2rem;color:#808080;padding:0 0.2rem;float:right;" ></i>
          </div>

          <div v-for="(item,index) in list" :key="index">
            <OrderCard :orderInfo="item"  />
          </div>

          <ListFooter :count="list.length" />

      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import OrderCard from './OrderCard'
import ListFooter from '../../components/ListFooter'
export default {
  components: {
    OrderCard,
    ListFooter
  },
  data() {
    return {
      list: [
        {
          GZ_ORDER_CODE: 'GZ20200701001',
          GZ_TITLE: '模拟测试故障-无法连接网络',
          GZ_DATE_TIME: '2020-07-01 14:32:45',
          GZ_CLIENT: '广州优启',
          BIZ_SID: 0,
          GZ_PRIORITY: 0
        }
      ],
      listFilter: {
        search_content: '',
        search_fields: ['GZ_TITLE'],
        gz_date_time: [],
        pagination: {
          limit: 30,
          page: 1
        },
        biz_sid: 0
      },
      visible: false,
      stepList: [
        {
          label: '全部',
          primitive: -1
        },
        {
          label: '待处理',
          primitive: 0
        },
        {
          label: '处理中',
          primitive: 2
        },
        {
          label: '已完成',
          primitive: 4
        }
      ],
      statData: {
        b0: 0,
        b2: 0,
        b4: 0
      }
    }
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    goDetail(order) {
      this.$router.goPage('/OrderDetail/' + order.GZ_ORDER_CODE)
    },
    initData() {
      var that = this
      that.$api.bz.getPlayerOrderList().then(res => {
        that.visible = true
        if (!res.success) {
          that.$toast.warning('获取数据失败');
          return
        }
        var data = res.data
        that.list = data
      })
    },
    changeBidSid() {
      var that = this
      that.initData()
    }
  },
  mounted() {
    var that = this
    that.initData()
  },
  activated() {
    var that = this
    that.initData()
  },
  deactivated() {
  }
}
</script>

<style scoped>

.us-v-app{
  background-color: #f2f2f2 !important;
}

.us-v-app /deep/ .theme--light.v-tabs-items{
  background-color: #f2f2f2 !important;
}

</style>
